import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';

@Component({
    selector: 'tt-product-menu',
    templateUrl: './product-menu.component.html',
    styleUrls: ['./product-menu.component.css'],
})
export class ProductMenuComponent {
    /**
     * The name of the product webpagemenu to load into generic webpagemnu component.
     */
    public webpageName = '';

    constructor(private state: StateService) {
        this.webpageName = this.state.getCurrentName();
    }
}
